<template>
  <div style="margin-bottom:30px">

    <!--  PC -->
    <el-form v-if="terminalType==='PC'" ref="form" inline>
      <el-form-item>
        <el-input placeholder="项目名称" style="width:150px;margin-right:20px" v-model="listQuery.projectNameLike" @keyup.enter.native="getList"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList">搜索</el-button>
      </el-form-item>

    </el-form>

    <div v-if="terminalType==='PC'" style="height: 20px;" />

    <el-table v-if="terminalType==='PC'" v-loading="listLoading" element-loading-text="给我一点时间" border fit highlight-current-row :data="projectList" style="width: 100%">
      <el-table-column prop="projectType" width="100" label="项目类型" header-align='center'>
      </el-table-column>
      <el-table-column label="关键项目" min-width="150" header-align='center'>
        <template slot-scope="scope">
          <div v-for="(item,index) of scope.row.projectName" :key="index">{{item}}</div>
        </template>
      </el-table-column>
      <el-table-column label="目标" min-width="300" header-align='center'>
        <template slot-scope="scope">
          <div v-for="(item,index) of scope.row.target" :key="index">{{item}}</div>
        </template>
      </el-table-column>

      <el-table-column prop="plot" width="200" label="策略" header-align='center'>
      </el-table-column>

      <el-table-column prop="resource" width="300" label="资源" header-align='center'>
        <template slot-scope="scope">
          <div v-for="(item,index) of scope.row.resource" :key="index">{{item}}</div>
        </template>
      </el-table-column>

      <el-table-column prop="leaderName" width="100" label="项目负责人" header-align='center'>
      </el-table-column>

      <el-table-column prop="memberNames" width="200" label="项目核心成员" header-align='center'>
      </el-table-column>

      <el-table-column prop="confirmPersonName" width="100" label="确认人" header-align='center'>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="100" align='center'>
        <template slot-scope="scope">
          <router-link :to="{path:'/projects/members/'+scope.row.projectId}">
            <el-button type="primary" size="mini">详情</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>

    <div v-show="!listLoading&&terminalType==='PC'" class="pagination-container" style="margin: 20px auto;margin-bottom: 100px;">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30,50]" :page-size="listQuery.size" layout="total, sizes, prev, pager, next, jumper" :total="listQuery.total">
      </el-pagination>
    </div>

    <!-- PC -->

    <!-- 移动端 -->
    <div v-if="terminalType==='mobile'" style="padding-bottom:70px;font-size:10px">
      <el-form ref="form" inline>
        <el-form-item>
          <el-input size="mini" placeholder="项目名称" style="width:150px;margin-right:20px" v-model="listQuery.projectNameLike" @keyup.enter.native="getList"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="getList">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table :max-height="windowHeight" v-loading="listLoading" element-loading-text="给我一点时间" border fit highlight-current-row :data="projectList" style="width: 100%;font-size:10px">
        <el-table-column prop="projectType" width="70" header-align='center' label="项目类型">
        </el-table-column>
        <el-table-column label="关键项目" width="150" header-align='center'>
          <template slot-scope="scope">
            <div v-for="(item,index) of scope.row.projectName" :key="index">{{item}}</div>
          </template>
        </el-table-column>
        <el-table-column label="目标" width="200" header-align='center'>
          <template slot-scope="scope">
            <div v-for="(item,index) of scope.row.target" :key="index">{{item}}</div>
          </template>
        </el-table-column>

      <el-table-column prop="plot" width="200" label="策略" header-align='center'>
      </el-table-column>

      <el-table-column prop="resource" width="300" label="资源" header-align='center'>
        <template slot-scope="scope">
          <div v-for="(item,index) of scope.row.resource" :key="index">{{item}}</div>
        </template>
      </el-table-column>

        <el-table-column prop="leaderName" width="90" header-align='center' label="项目负责人">
        </el-table-column>

        <el-table-column prop="memberNames" width="160" header-align='center' label="项目核心成员">
        </el-table-column>

      <el-table-column prop="confirmPersonName" width="100" label="确认人" header-align='center'>
      </el-table-column>

        <el-table-column label="操作" fixed="right" width="80" align='center'>
          <template slot-scope="scope">
            <router-link :to="{path:'/projects/members/'+scope.row.projectId}">
              <el-button type="primary" size="mini">详情</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <div v-show="!listLoading" class="pagination-container" style="margin: 10px auto;margin-bottom: 50px;">
        <el-pagination :page-size='20' layout="prev, pager, next" :total="listQuery.total" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

    <!-- 移动端 -->

  </div>

</template>

<script>
import { list, addProjectApi } from "@/api/projects";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      listQuery: {
        projectNameLike: "",
        page: 1,
        size: 20,
        total: 0,
      },
      windowHeight: Number(document.documentElement.clientHeight) - 120, // 实时屏幕高度
      listLoading: false,
      projectList: [],
      addDialog: false,
      newProject: {
        projectName: "",
        target: "",
      },
      options: [],
    };
  },
  computed: {
    ...mapGetters(["terminalType"]),
  },
  created() {
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.listQuery.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      if (this.listQuery.projectNameLike === "") {
        this.listQuery.projectNameLike = null;
      }
      list(this.listQuery)
        .then((r) => {
          r.data.data.map((item) => {
            item.projectName = item.projectName.split("/");
            item.target = item.target.split("/");
            item.resource = item.resource.split("/");
          });
          this.projectList = r.data.data;
          this.listQuery.total = r.data.total;
          this.listQuery.size = r.data.size;
          window.console.log(r);
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = true;
        });
    },
    addProject() {
      this.addDialog = true;
    },
    addProjectSubmit() {
      addProjectApi(this.newProject).then(() => {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.addDialog = false;
        this.getList();
      });
    },
  },
};
</script>

<style scoped>
</style>
